import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=b6e1cb54&scoped=true&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"
import style0 from "./shopList.vue?vue&type=style&index=0&id=b6e1cb54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e1cb54",
  null
  
)

export default component.exports